"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SEARCH_BASKET_UI = exports.REMOVE_CLAIM_FROM_BASKET_UI = exports.BASKET_STATUSES_MAP = void 0;
var SEARCH_BASKET_UI = exports.SEARCH_BASKET_UI = 'SEARCH_BASKET_FORM_UI';
var REMOVE_CLAIM_FROM_BASKET_UI = exports.REMOVE_CLAIM_FROM_BASKET_UI = 'REMOVE_CLAIM_FROM_BASKET_UI';
var BASKET_STATUSES_MAP = exports.BASKET_STATUSES_MAP = {
  ARCHIVE: 'ARCHIVE',
  NOT_SEND: 'NOT_SEND',
  SEND: 'SEND',
  ALL: 'ALL'
};